import {
  Box,
  Button,
  Card,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React, { useState, useEffect } from 'react';
import ConfirmExchangeCompleteAgent from 'assets/images/ConfirmExchangeCompleteAgent.png';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

const ConfirmExchangeComplete = (props) => {
  let {
    bannerDetails,
    isAgentDashboard,
    proeprtyID,
    setOpenExchange,
    setShowExchange,
  } = props;
  const theme = useTheme();
  const history = useHistory();
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matchesxs = useMediaQuery(theme.breakpoints.down('xs'));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));
  const location = useLocation();

  useEffect(() => {
    if (location.state?.isFromConfirmExchange) {
      setOpenExchange(true);
      setShowExchange(true);
    }
  }, []);

  const ConfirmExchangeRedirection = (propertyId) => {
    if (propertyId) {
      history.push({
        pathname: `/dashboard/view-dashboard/${propertyId}`,
        state: {
          isFromConfirmExchange: true,
        },
      });
    }
  };

  return (
    <>
      <Grid
        container
        sx={{
          scrollbarWidth: 'none',
          background: 'white',
          margin: '0 auto',
          zIndex: 1,
        }}
      >
        <Card
          variant="outlined"
          sx={{
            background: 'rgba(33, 132, 253, 0.8)',
            width: '100%',
            borderRadius: '20px',
            p: matchessm ? 0 : 2,
            display: 'flex',
            flexDirection: 'row',
            height: matchessm ? 390 : matchesmd ? 330 : 300,
          }}
        >
          <Grid container alignItems={'center'}>
            <Grid item xs={12} md={8} display="flex" alignItems="center">
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'start',
                  width: '100%',
                  px: matchessm ? 1.5 : 3,
                  gap: matchessm ? 1.5 : 0.6,
                }}
              >
                <Typography
                  sx={{
                    color: '#FFF',
                    fontWeight: 300,
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'poppins',
                    textTransform: 'capitalize',
                    marginTop: matchessm && '-60px',
                  }}
                >
                  {bannerDetails?.propertyAddress}.
                </Typography>

                <Typography
                  sx={{
                    fontSize: !matches450 ? '32px' : '18px',
                    fontWeight: 600,
                    color: '#FFF',
                    fontFamily: 'poppins',
                  }}
                >
                  Confirm Exchange Completed
                </Typography>

                <Typography
                  sx={{
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'poppins',
                    fontWeight: 300,
                    mt: 1.5,
                    color: '#FFF',
                  }}
                >
                  Both Buyer and Vendor Contracts have been signed. Deposit
                  payment has been confirmed. Please confirm exchange is
                  complete for{' '}
                  <Typography
                    component="span"
                    sx={{
                      color: '#FFF',
                      fontWeight: matchessm ? 600 : 700,
                      fontSize: matchessm ? '14px' : '16px',
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    }}
                  >
                    {bannerDetails?.propertyAddress}
                  </Typography>
                </Typography>

                <Stack
                  direction="row"
                  spacing={2}
                  mt={2.5}
                  alignItems="center"
                  flexWrap="wrap"
                  justifyContent={matchessm && 'space-between'}
                >
                  <Button
                    onClick={() => {
                      if (isAgentDashboard) {
                        ConfirmExchangeRedirection(proeprtyID);
                      } else {
                        setOpenExchange(true);
                        setShowExchange(true);
                      }
                    }}
                    sx={{
                      px: 4,
                      height: matchessm ? 35 : 42,
                      borderRadius: '5px',
                      fontSize: matchessm ? '12px' : '14px',
                      textTransform: 'none',
                      border: '1px solid #E6F2FF',
                      backgroundColor: '#FFF',
                      color: '#2184FD',
                      fontWeight: 400,
                      fontFamily: 'poppins',
                      '&:hover': {
                        bgcolor: '#FFFFFF',
                        color: '#2184FD',
                      },
                    }}
                  >
                    Confirm Exchange Completed
                  </Button>
                </Stack>
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              md={4}
              display={matchesmd ? 'none' : 'block'}
              textAlign="center"
            >
              <img
                src={ConfirmExchangeCompleteAgent}
                alt="ConfirmExchangeCompleteAgent"
                style={{ objectFit: 'contain', height: '275px' }}
              />
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </>
  );
};

export default ConfirmExchangeComplete;
